export const tagTypes = {
  stopover: 'FHFHF',
};
